/**
 * Lanificio — mega-menu in de header (sections/lan-header.liquid).
 *
 * Desktop (vanaf 1280px):
 * - Openen bij hover na 120 ms, sluiten 250 ms na het verlaten van item én
 *   paneel, zodat schuin naar het paneel bewegen niet flikkert.
 * - Toetsenbord: het pijltje naast het menu-item (een <button> met
 *   aria-expanded/aria-controls) opent met Enter of spatie; Escape sluit en
 *   zet de focus terug op dat pijltje; Tab loopt door het paneel en sluit
 *   het zodra de focus eruit gaat. Klikken op het woord zelf volgt de link.
 * - De pagina wordt licht gedimd; klikken op de dimlaag sluit.
 *
 * Mobiel menu: uitklappers (knop met aria-expanded) met een hoogte-animatie
 * via CSS (grid-template-rows).
 *
 * Beelden in beide laden pas bij de eerste keer openen (data-src/-srcset,
 * snippets/lan-mega-img.liquid).
 */
(() => {
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 250;
  const desktop = window.matchMedia('(min-width: 1280px)');

  function loadImages(root) {
    root.querySelectorAll('img[data-srcset]').forEach((img) => {
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
  }

  function initDesktop(header) {
    const items = [...header.querySelectorAll('[data-lan-mega]')];
    if (!items.length) return;
    const overlay = header.querySelector('[data-lan-mega-overlay]');
    let current = null;

    items.forEach((item) => {
      const toggle = item.querySelector('[data-lan-mega-toggle]');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      let openTimer = null;
      let closeTimer = null;

      const open = () => {
        clearTimeout(closeTimer);
        if (current && current !== api) current.close(true);
        loadImages(panel);
        // Compact paneel (OVER): links gelijk met het eigen menu-item, maar
        // binnen de header blijven.
        if (panel.classList.contains('lan-mega--over')) {
          const inner = item.offsetParent;
          const max = inner ? inner.clientWidth - panel.offsetWidth - 16 : Infinity;
          panel.style.setProperty('--lan-mega-left', `${Math.max(16, Math.min(item.offsetLeft - 32, max))}px`);
        }
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        header.setAttribute('data-mega-open', '');
        if (overlay) overlay.classList.add('is-visible');
        current = api;
      };

      const close = (instant) => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (current === api) {
          current = null;
          if (!instant) {
            header.removeAttribute('data-mega-open');
            if (overlay) overlay.classList.remove('is-visible');
          }
        }
      };

      const api = { item, open, close, toggle };

      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !desktop.matches) return;
        clearTimeout(closeTimer);
        if (item.classList.contains('is-open')) return;
        openTimer = setTimeout(open, current ? 0 : OPEN_DELAY);
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => close(false), CLOSE_DELAY);
      });

      toggle.addEventListener('click', () => {
        if (item.classList.contains('is-open')) close(false);
        else open();
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
        event.stopPropagation();
        close(false);
        toggle.focus();
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget) && item.classList.contains('is-open')) close(false);
      });

      item._lanMega = api;
    });

    if (overlay) {
      overlay.addEventListener('click', () => current && current.close(false));
    }

    desktop.addEventListener('change', () => current && current.close(false));
  }

  function initDrawer(root) {
    root.querySelectorAll('[data-lan-drawer-toggle]').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        if (!expanded) loadImages(panel);
        button.setAttribute('aria-expanded', String(!expanded));
        panel.classList.toggle('is-open', !expanded);
      });
    });
  }

  function init() {
    const header = document.getElementById('header-component');
    if (header) initDesktop(header);
    const drawer = document.getElementById('lan-header-drawer');
    if (drawer) initDrawer(drawer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
